import { render, staticRenderFns } from "./BoasVindas.vue?vue&type=template&id=5bf846fe&scoped=true&"
import script from "./BoasVindas.vue?vue&type=script&lang=js&"
export * from "./BoasVindas.vue?vue&type=script&lang=js&"
import style0 from "./BoasVindas.vue?vue&type=style&index=0&id=5bf846fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf846fe",
  null
  
)

export default component.exports